export default __webpack_public_path__ + "white_horizontal_logo.svg";